import { useEffect } from "react";
import ReactGA from "react-ga4";
import { Link as RouterLink } from "react-router-dom";
import { Box, Heading, Link, Text, useColorModeValue } from "@chakra-ui/react";
import { AboutStory, AppDownloads } from "../components/common/AppIntroduction";
import PageLayout, { PageHeader } from "../components/layout/PageLayout";
import { TONE, TYPE } from "../styles/theme";

export default function AboutPage() {
  const t = useColorModeValue(TONE.light, TONE.dark);
  useEffect(() => { ReactGA.send({ hitType: "pageview", page: "/about", title: "About Kuthé" }); }, []);

  const sections = [
    ["Independent by intention.", "Kuthé is built around independent, owner-operated shops. AI-assisted checks help filter out chains and franchises, while collections offer another starting point for discovery. Listings aren’t a guarantee: information can be incomplete, and a shop’s hours or ownership can change."],
    ["The app goes with you.", "The mobile app is where Kuthé is growing. Discover shops, save favorites on your device, and explore collections. This website is a glimpse of that experience, with a map to try and shop pages you can share."],
  ];

  return (
    <PageLayout narrow>
      <PageHeader title="About Kuthé" />
      <AboutStory />
      {sections.map(([heading, body]) => (
        <Box key={heading} mt={{ base: 10, md: 12 }}>
          <Heading as="h2" fontSize={TYPE.sectionTitle} fontWeight={400} mb={4}>{heading}</Heading>
          <Text color={t.dim} fontSize={TYPE.body} lineHeight={1.8}>{body}</Text>
        </Box>
      ))}
      <Box mt={{ base: 10, md: 12 }}>
        <Heading as="h2" fontSize={TYPE.sectionTitle} fontWeight={400} mb={4}>Help make the map better.</Heading>
        <Text color={t.dim} fontSize={TYPE.body} lineHeight={1.8}>
          Know a shop we’re missing? Own a café with details to correct? Have a question about the app?{" "}
          <Link as={RouterLink} to="/contact" textDecoration="underline">Send a message</Link>.
          Include the shop’s name and city if it’s about a listing.
        </Text>
      </Box>
      <Box mt={{ base: 10, md: 12 }}><AppDownloads campaign="about" /></Box>
    </PageLayout>
  );
}
